import styled from "styled-components";


export const DropdownMenuContent = styled.div`
    visibility: hidden;
    display: block;
    position: absolute;
    background-color: ${({ theme }) => theme.bg3};
    min-width: 220px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
    a, span {
        cursor: pointer;
        font-size: 0.8rem;
        padding: 12px 16px;
        display: block;
        &:hover {background-color: ${({ theme }) => theme.bg4}}
    }

`


export const DropdownMenuContainer = styled.div`
    position: relative;
    display: inline-block;
    text-decoration: none;

    &:hover {
        cursor: pointer;
        .DropdownMenuContent {
            visibility: visible;
        }
    }
`
